/**
 * Acceptable Date Formats to use with date formatting functions.
 * TODO: simplify as needed to improve consistency.
 */
const dateWithTimeFormat = ['M/D/YYYY, h:mm a', 'M/D/YYYY, h:mm a z', 'MMM D, YYYY, h:mm a',
/** Example: Jun 5, 2023, 1:00 pm PST */
'MMM D, YYYY, h:mm a z', 'MMMM D, YYYY, h:mm a',
/** Example: 13:00:00 */
'HH:mm:ss', 'dddd, MMM. D, YYYY at h - h A', 'h:mm a', 'h:mm A', 'h:mm a z', 'h a', 'h', 'a'];
const isOfTypeDateWithTimeFormat = keyInput => {
  var _a;

  return ((_a = dateWithTimeFormat.find(format => format === keyInput)) !== null && _a !== void 0 ? _a : []).length > 0;
};

export { isOfTypeDateWithTimeFormat };
